import { AuthContext } from '@repo-level/core-front';
import { AB_TESTS } from 'modules/abTesting/constants';
import { useABTestingV2 } from 'modules/abTesting/hooks/useABTesting';
import {
  isPwaOrAndroidApp,
  STANDALONE_MEDIA_QUERY,
} from 'modules/missions/helpers/appDetection';
import { canAssignMission } from 'modules/missions/helpers/mission';
import { MissionId } from 'modules/missions/types';
import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useAssignMission } from './useAssignMission';

export const useWn3Mission = () => {
  const { user } = useContext(AuthContext);
  const { isB: isShowQuests } = useABTestingV2({ experiment: AB_TESTS.QUESTS });
  const { requestAssignMission } = useAssignMission();

  const sourceRef = useRef(
    new URLSearchParams(window.location.search).get('source')
  );

  const isAssignMission = useMemo(
    () => canAssignMission(user, isShowQuests, MissionId.WN_3),
    [isShowQuests, user]
  );

  const tryAssign = useCallback(() => {
    requestAssignMission(MissionId.WN_3);
  }, [requestAssignMission]);

  useEffect(() => {
    if (!isAssignMission || typeof window === 'undefined') return;
    if (isPwaOrAndroidApp(sourceRef.current)) tryAssign();

    const mediaQuery = window.matchMedia(STANDALONE_MEDIA_QUERY);
    const handler = ({ matches }: MediaQueryListEvent) => {
      if (matches) tryAssign();
    };

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [isAssignMission, tryAssign]);
};
